// The browser tab's access token, in module memory.
//
// Feature 2026-09-21-dp-session-cookie, decision D2 and security chain C1 step 3: the refresh
// token moves into an HttpOnly cookie the server owns, and the access token stops touching Web
// Storage. This file is where it lives instead.
import { computeExpiresAt } from './token-utils.js';
/** The access token this tab holds. `null` before the first `set` and after `clear`. */
let heldAccessToken = null;
/** The held token's expiry in epoch milliseconds, derived from its own `exp` claim. */
let heldExpiresAt = null;
/** The process-wide instance: one per module graph, so one per tab. */
export const sessionStore = {
    set(accessToken) {
        // Compute first. `computeExpiresAt` throws on a string that is not a JWT, and a partial write
        // would leave a token with the previous token's expiry.
        const expiry = computeExpiresAt(accessToken);
        heldAccessToken = accessToken;
        heldExpiresAt = expiry;
    },
    clear() {
        heldAccessToken = null;
        heldExpiresAt = null;
    },
    get() {
        return heldAccessToken;
    },
    getExpiresAt() {
        return heldExpiresAt;
    },
};
//# sourceMappingURL=session-store.js.map